import { Directive, ViewContainerRef } from '@angular/core';
export class D3TooltipHostDirective {
/**
 * @param {?} viewContainerRef
 */
constructor(public viewContainerRef: ViewContainerRef) { }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[d3TooltipHost]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function D3TooltipHostDirective_tsickle_Closure_declarations() {
/** @type {?} */
D3TooltipHostDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
D3TooltipHostDirective.ctorParameters;
/** @type {?} */
D3TooltipHostDirective.prototype.viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
